/* app/js/src/components/clipping-studio/shared/catalog-card/clipping-studio-catalog-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  min-width: 0;
}
.catalog-card {
  width: 100%;
  min-width: 0;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.catalog-card:hover {
  border-color: rgba(22, 177, 255, 0.5);
}
.catalog-card--disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: auto;
}
.catalog-card__card-thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  background: rgba(35, 47, 58, 0.05);
}
.catalog-card__card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  opacity: 0.8;
  transition: transform 0.4s ease;
}
.catalog-card:hover .catalog-card__card-img {
  transform: scale(1.05);
}
.catalog-card__card-duration {
  position: absolute;
  left: 4px;
  bottom: 4px;
  padding: 4px;
  font-size: 10px;
  letter-spacing: 0.1px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
}
.catalog-card__card-overlay {
  background-color: rgba(35, 47, 58, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: none;
  justify-content: center;
  align-items: center;
  animation: catalog-card-fadeIn 0.3s forwards;
}
.catalog-card:hover .catalog-card__card-overlay {
  display: flex;
}
.catalog-card__card-overlay section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
  width: 70%;
  margin: 0 auto;
}
.catalog-card__card-overlay section > button {
  display: block;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  padding: 0;
  position: relative;
  cursor: pointer;
  color: #93a9bf;
}
.catalog-card__card-overlay section > button > svg {
  width: 20px;
  height: 20px;
  display: block;
  transition: all 0.2s ease;
}
.catalog-card__card-overlay section > button:focus {
  outline: none;
}
.catalog-card__card-overlay section > button:hover {
  color: #ffffff;
}
.catalog-card__card-overlay section > button:hover::after {
  transform: translateY(5px);
  opacity: 1;
}
.catalog-card__card-overlay section > button::after {
  content: attr(data-title);
  color: #ffffff;
  font-size: 0.7em;
  margin-left: -10px;
  display: block;
  opacity: 0;
  position: absolute;
  left: -50%;
  top: 23px;
  width: 300%;
  transition: all 0.2s ease;
  transform: translateY(15px);
}
.catalog-card__card-info {
  padding: 8px;
}
.catalog-card__card-title {
  font-size: 11px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.85);
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@keyframes catalog-card-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=clipping-studio-catalog-card.component.css.map */
